export function range(start: number, end: number, step: number = 1) {
    const arr = [];
    if (start < end && step > 0) {
        for (let i = start; i < end; i += step) {
            arr.push(i);
        }
    } else if (start > end && step < 0) {
        for (let i = start; i > end; i += step) {
            arr.push(i);
        }
    }

    return arr;
}
